import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { BTN_DISABLE, EMPTY_STRING } from '@app/constants';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnChanges {
  @Input() titulo = EMPTY_STRING;
  @Input() className = EMPTY_STRING;
  @Input() tema = EMPTY_STRING;
  @Input() icon = EMPTY_STRING;
  @Input() iconsSave = EMPTY_STRING;
  @Input() disable = false;
  @Input() iconPlus = EMPTY_STRING;
  @Input() notifiaction? = false;
  @Input() isLoading = false;
  @Input() showCounter: boolean = false;
  @Input() counter: number = 0;
  @Input() iconSize = 16;
  @Output() clickAction = new EventEmitter();

  emptyString = EMPTY_STRING;

  onClick(event: MouseEvent) {
    if (this.disable) return;
    this.clickAction.emit(event);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes[BTN_DISABLE]) {
      this.disable = changes[BTN_DISABLE].currentValue;
    }
  }
}
